export default __webpack_public_path__ + "static/media/Cristo Redentor.ff1fa5bc.svg";